module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 data.actions.forEach(function(a) { ;
__p += '\n';
 if (a.icon) { ;
__p += '\n<a href="#" data-action="' +
((__t = ( a.action )) == null ? '' : __t) +
'" class="' +
((__t = ( a.action ? "tooltipped tooltipped-w tooltipped-multiline" : "no-tooltip" )) == null ? '' : __t) +
' ' +
((__t = ( a.action ? "has-action" : "no-action" )) == null ? '' : __t) +
'" aria-label="' +
((__t = ( a.tooltip )) == null ? '' : __t) +
'">\n    <i class="' +
((__t = ( a.icon )) == null ? '' : __t) +
'"></i>\n    <div class="action-label">' +
((__t = ( a.label )) == null ? '' : __t) +
'</div>\n</a>\n';
 } ;
__p += '\n';
 if (a.button) { ;
__p += '\n<div data-action="' +
((__t = ( a.action )) == null ? '' : __t) +
'" class="no-tooltip ' +
((__t = ( a.action ? "has-action" : "no-action" )) == null ? '' : __t) +
'" aria-label="' +
((__t = ( a.tooltip )) == null ? '' : __t) +
'">\n    <button type="button" class="btn btn-blue-alt">' +
((__t = ( a.label )) == null ? '' : __t) +
'</button>\n</div>\n';
 } ;
__p += '\n';
 }) ;

return __p
}